import { faker } from "@faker-js/faker";

import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import {
  QuestionBankData,
  QuestionBankList,
} from "@/builders/types/question-bank";
import {
  CreateQuestionBank,
  CreateQuestionBankResponse,
} from "@/builders/types/questions";

import dayjs from "dayjs";

const get = function (params?: FilterParams) {
  return api
    .get<QuestionBankList>("/question-banks", { params })
    .then(({ data }) => data);
};

const post = function (data: CreateQuestionBank) {
  return api.post<CreateQuestionBankResponse>("/question-banks", data);
};

export const question_bank = {
  get,
  post,
};

export function useFakeQuestionBankData(index?: number): QuestionBankData {
  faker.seed(index);

  return {
    course: {
      id: index,
      title: faker.lorem.words({ min: 1, max: 3 }),
    },
    id: index,
    organization: {
      id: index,
      name: faker.company.name(),
      unique_link: faker.internet.url(),
    },
    title: faker.lorem.words({ min: 1, max: 5 }),
    total_questions: faker.number.int({ min: 10, max: 100 }),
  } as QuestionBankData;
}

export function useFakeQuestionBankList(): QuestionBankList {
  faker.seed(dayjs().day());

  const data = Array.from(
    { length: faker.number.int({ min: 3, max: 7 }) },
    (_, index) => useFakeQuestionBankData(index)
  );

  return {
    data,
    page_size: 10,
    current_page: 1,
    last_page: 1,
    total: data.length,
    next_page_url: faker.internet.url(),
    prev_page_url: faker.internet.url(),
  } as QuestionBankList;
}
